const StateEnum = {
  BANKING: 'banking',
  LEGAL_REPRESENTS: 'legal_represents',
  SELLING_POINT: 'selling_point',
  FINAL: 'final_selling_point',
};

export default StateEnum;
